import { FolderGit2 } from 'lucide-react';
import { createWebRegistration } from '@reflex/plugin-api/create-web-registration';

export default createWebRegistration({
  components: {
    '@reflex/plugin-projects/web/ProjectsPage': () =>
      import('./ProjectsPage').then((m) => ({ default: m.ProjectsPage })),
    '@reflex/plugin-projects/web/ProjectDetailPage': () =>
      import('./ProjectDetailPage').then((m) => ({ default: m.ProjectDetailPage })),
    '@reflex/plugin-projects/web/ProjectPreview': () =>
      import('./ProjectPreview').then((m) => ({ default: m.ProjectPreview })),
  },
  icons: { FolderGit2 },
});
